import { createSelector } from '@reduxjs/toolkit'
import { selectIsLebtItemPoliciesEnabled } from './selectIsLebtItemPoliciesEnabled'
import { getCartEvaluationItems } from 'checkout/selectors/getCartEvaluationItems'

/**
 * Whether the whole-cart evaluation requires an inline trip request form for the given vertical.
 * Returns undefined when item policies are off, so the legacy selector logic decides instead.
 */
export function makeSelectCartEvaluationRequiresTripRequestForm(
  itemPolicyType: App.BusinessTraveller.ItemPolicyType,
) {
  return createSelector(
    selectIsLebtItemPoliciesEnabled,
    (state: App.State) => state.businessTraveller.cartEvaluation.result?.approval.required,
    getCartEvaluationItems,
    (isItemPoliciesEnabled, approvalRequired, cartEvaluationItems): boolean | undefined => {
      if (!isItemPoliciesEnabled) {
        return undefined
      }
      return (
        !!approvalRequired &&
        cartEvaluationItems.data.some((item) => item.itemPolicyLookup.itemPolicyType === itemPolicyType)
      )
    },
  )
}
